module.exports = __webpack_public_path__ + "static/media/19ESCAP40.2003e310.jpg";